import React from "react";
import { Button, createStyles, Flex, Paper, Text, useMantineTheme } from "@mantine/core";

interface IJsonBlock {
	content: string;
	isValid?: boolean;
	onApply: (json: string) => void;
}

export const JsonBlock: React.FC<IJsonBlock> = ({ content, isValid, onApply }) => {
	const theme = useMantineTheme();
	const { classes } = useStyles();

	return (
		<Flex style={{ flexDirection: "column" }}>
			{isValid ? (
				<>
					<Flex className={classes.jsonTitle}>
						<Text>JSON</Text>
						<Flex style={{ justifyContent: "center" }}>
							<Button
								variant="outline"
								size="xs"
								w={"fit-content"}
								disabled={!isValid}
								onClick={() => {
									onApply(content);
								}}
							>
								Apply
							</Button>
						</Flex>
					</Flex>
					<Paper className={classes.jsonBlock}>
						<Text>
							<pre style={{ whiteSpace: "pre-wrap", wordWrap: "break-word", fontFamily: "Open Sans, sans-serif" }}>
								{content}
							</pre>
						</Text>
					</Paper>
				</>
			) : (
				<>
					<Flex className={classes.jsonTitle}>
						<Text color="red">JSON failed validation</Text>
					</Flex>
					<Paper className={classes.jsonBlock}>
						<Text>
							<pre style={{ whiteSpace: "pre-wrap", wordWrap: "break-word", fontFamily: "Open Sans, sans-serif" }}>
								More information about failed validation can be found in the console.
							</pre>
						</Text>
					</Paper>
				</>
			)}
		</Flex>
	);
};

const useStyles = createStyles((theme) => ({
	jsonTitle: {
		backgroundColor: theme.colors.dark[7],
		padding: "0.5rem 1rem",
		color: "white",
		marginTop: "1rem",
		marginBottom: "0.1rem",
		alignItems: "center",
		justifyContent: "space-between",
		borderTopLeftRadius: "0.5rem",
		borderTopRightRadius: "0.5rem",
	},

	jsonBlock: {
		backgroundColor: theme.colors.dark[8],
		padding: "1rem",
		color: "white",
		maxHeight: "20rem",
		overflowY: "auto",
		borderTopLeftRadius: 0,
		borderTopRightRadius: 0,
		borderBottomLeftRadius: "0.5rem",
		borderBottomRightRadius: "0.5rem",
	},
}));
